import { gql, useMutation } from '@apollo/client'

export const UPDATE_ARTIST = gql`
  mutation ($input: ArtistUpdate) {
    updateArtist(input: $input) {
      id
      name
      bio
      facebook_id
      gps_status
      opus_id
      __typename
    }
  }
`

export const useUpdateArtist = () => {
  const [mutate, { data, loading, error }] = useMutation(UPDATE_ARTIST, {
    update(cache) {
      cache.modify({
        fields: {
          getArtists() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
